module.exports = __webpack_public_path__ + "static/media/simulation-select-fixed-value.f607da0b.svg";